import React, { FC } from 'react';

import { GRADIENT_INPUT_STYLE } from 'views/OfferDesign/OfferDesign.consts';
import { normalizeGradientColor } from 'views/OfferDesign/OfferDesign.utils';

import AcGradientInput from 'components/AcGradientInput/AcGradientInput';
import Input from 'components/Input/Input';

import {
  GradientFieldConfig,
  NumberFieldConfig,
  Spacing,
  SPACING_MAP
} from '../FormFields.types';

import { useFormFieldsContext } from '../../../context';

interface IFormFieldsBorderRowProps {
  gradientConfig: GradientFieldConfig;
  widthConfig: NumberFieldConfig;
  spacing?: Spacing;
}

export const FormFieldsBorderRow: FC<IFormFieldsBorderRowProps> = ({
  gradientConfig,
  widthConfig,
  spacing = 'none'
}): React.ReactElement => {
  const { values, getFieldProps, setFieldValue } = useFormFieldsContext();
  const gradientFieldProps = getFieldProps(gradientConfig.name);
  const widthFieldProps = getFieldProps(widthConfig.name);
  const gradientTestIdPrefix = gradientConfig.dataTestId;

  return (
    <div className={`flex gap-5 ${SPACING_MAP[spacing]}`.trim()}>
      <div className={`flex-1 ${GRADIENT_INPUT_STYLE}`}>
        <AcGradientInput
          header={gradientConfig.header}
          required={gradientConfig.required}
          name={gradientConfig.name}
          dataTestId={gradientConfig.dataTestId}
          dataTestPopoverId={
            gradientTestIdPrefix ? `${gradientTestIdPrefix}-popover` : undefined
          }
          dataTestColorOneId={
            gradientTestIdPrefix ? `${gradientTestIdPrefix}-color-one` : undefined
          }
          dataTestColorTwoId={
            gradientTestIdPrefix ? `${gradientTestIdPrefix}-color-two` : undefined
          }
          dataTestGradientTypeId={
            gradientTestIdPrefix
              ? `${gradientTestIdPrefix}-gradient-type`
              : undefined
          }
          dataTestGradientDirectionId={
            gradientTestIdPrefix
              ? `${gradientTestIdPrefix}-gradient-direction`
              : undefined
          }
          defaultValue={
            normalizeGradientColor(
              values[gradientConfig.name as keyof typeof values],
              gradientConfig.fallback
            )
          }
          onChange={gradientFieldProps.onChange}
          onBlur={gradientFieldProps.onBlur}
          setValue={setFieldValue}
        />
      </div>
      <Input
        label={widthConfig.label}
        isRequired={widthConfig.isRequired}
        name={widthConfig.name}
        type="number"
        min={widthConfig.min}
        max={widthConfig.max}
        value={Number(values[widthConfig.name as keyof typeof values] ?? 0)}
        onChange={widthFieldProps.onChange}
        onBlur={widthFieldProps.onBlur}
        leftIcon={widthConfig.leftIcon}
        leftIconStyles={widthConfig.leftIconStyles}
        className="flex-1"
      />
    </div>
  );
};
